import '../cfcDashboard/DashboardHeader.scss';

/**
 * CurrentBillingChartLoading Component
 * 
 * A placeholder loading component for the current billing chart section of the dashboard.
 * It renders a styled div to indicate loading.
 *
 * @component
 * @memberof Components
 * @example
 * return (
 *   <CurrentBillingChartLoading />
 * )
 *
 * @returns {JSX.Element} A div styled as a loading placeholder for the billing chart.
 */
const CurrentBillingChartLoading = () => {

    return (
        <div className="dashboard-header" style={{ width: 'auto', backgroundColor: '#edeff2', height: '35vh' }} >
        </div>
    )
}

export default CurrentBillingChartLoading